import { crmApiFetch } from "../../services/crmApi";

async function parseResponse(response, fallbackMessage) {
    let payload = {};
    try {
        payload = await response.json();
    } catch {
        payload = {};
    }
    if (!response.ok) {
        throw new Error(payload.error || fallbackMessage);
    }
    return payload;
}

export async function getAccounts() {
    const response = await crmApiFetch("/api/accounts", { method: "GET" });
    const payload = await parseResponse(response, "Failed to fetch accounts");
    return payload.accounts || [];
}

export async function getAccount(accountId) {
    const response = await crmApiFetch(`/api/accounts/${accountId}`, { method: "GET" });
    const payload = await parseResponse(response, "Failed to fetch account");
    return payload.account;
}

export async function createAccount(account) {
    const response = await crmApiFetch("/api/accounts", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(account),
    });
    const payload = await parseResponse(response, "Failed to create account");
    return payload.account;
}

export async function updateAccount(accountId, account) {
    const response = await crmApiFetch(`/api/accounts/${accountId}`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(account),
    });
    const payload = await parseResponse(response, "Failed to update account");
    return payload.account;
}

export async function getLeadForgeAssessment(accountId) {
    const response = await crmApiFetch(`/api/accounts/${accountId}/leadforge-assessment`, { method: "GET" });
    const payload = await parseResponse(response, "Failed to fetch LeadForge assessment");
    return payload.assessment;
}

export async function saveLeadForgeAssessment(accountId, assessment) {
    const response = await crmApiFetch(`/api/accounts/${accountId}/leadforge-assessment`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(assessment),
    });
    const payload = await parseResponse(response, "Failed to save LeadForge assessment");
    return payload.assessment;
}